if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('complementary-products')) {
             setTimeout(() => {
                window.dispatchEvent(new Event("scroll"));
             }, 1000);
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
}

let counter = 0;
let selector = ".product__tax.caption.rte"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        setTimeout(() => {
          const priceType = document.querySelector('.price__container[bss-b2b-product-price] span');
          switch (priceType.getAttribute('class')) {
            case 'bss-b2b-compare-price-no-vat':
            case 'bss-b2b-price-no-vat':
              element.innerHTML = 'IVA não incluído.'
              break;
            case 'bss-b2b-compare-price-has-vat':
            case 'bss-b2b-price-has-vat':
              element.innerHTML = 'IVA incluído.'
              break;
          
            default:
              break;
          }
        }, 2000);
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);


function initNetTermWhenCartDrawerOpen() {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;

  let lastIsOpen = drawer.classList.contains("active");

  const triggerInit = () => {
    console.log("Cart drawer mở → chạy BSS_B2B + DOMContentLoaded");
    BSS_B2B.nt.initFunction();
    document.dispatchEvent(new Event("DOMContentLoaded"));
  };

  const checkOpen = () => {
    const isOpen = drawer.classList.contains("active");

    if (!lastIsOpen && isOpen) {
      triggerInit();
    }
    lastIsOpen = isOpen;
  };

  checkOpen();

  new MutationObserver(checkOpen).observe(drawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

document.addEventListener("bss_b2b:check_nt_rule_done", e => {
  console.log("bss_b2b:check_nt_rule_done");
  if(!BSS_B2B?.nt?.appliedRule) {
    document.querySelector("#cart-notification #bss-b2b-net-term-button-wrapper")?.remove();
  }
})

const checkNT = setInterval(() => {
  if (
    window.BSS_B2B &&
    BSS_B2B.nt &&
    BSS_B2B.nt.initFunction
  ) {
    BSS_B2B.nt.initFunction();
    document.dispatchEvent(new Event("DOMContentLoaded"));

    clearInterval(checkNT);
  }
}, 100);


document.addEventListener("openCartNoti", e => {
  console.log("openCartNoti");
  setTimeout(() => {
      BSS_B2B.nt.initFunction()
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }, 150);
});

document.addEventListener("DOMContentLoaded", initNetTermWhenCartDrawerOpen, { once: true });

document.body.addEventListener("click", function (e) {
  if (e.target.closest(".quantity__button") || e.target.closest(".cart-remove-button")) {
    console.log("Quantity button clicked → reset NetTerm");

    setTimeout(() => {
      BSS_B2B.nt.initFunction()
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }, 150);
  }
});


document.addEventListener("bss_b2b:show_nt_modal", e => {
  setTimeout(() => {
    const headerModal = document.querySelector(".b2b-nt-modal-header");
    if(headerModal && headerModal.innerText.includes("-")) return;
    headerModal.innerText += ` - ${BSS_B2B.nt.appliedRule.name}`;
  }, 100)
});

setTimeout(() => {
  const netTermBtn = document.querySelector("#cart-notification #bss-b2b-net-term-button")
  if(!netTermBtn) return;
    netTermBtn.addEventListener("click", e => {
      document.querySelector("#cart-icon-bubble").click()
      setTimeout(() => {
        const targetButton = document.querySelector('.cart__ctas-container #bss-b2b-net-term-button');
        if (targetButton) {
          targetButton.click();
        }
      }, 2000)
    })
}, 1500);

(function () {
  try {
    window.sessionStorage.setItem('bssB2BTaxDisplayMode', 'excl');
  } catch (e) {}
})();

window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };

function styleTdSwitch(tdSwitch) {
  tdSwitch.style.position = "static";
  tdSwitch.style.left = "auto";
  tdSwitch.style.bottom = "auto";
  tdSwitch.style.zIndex = "1";
  tdSwitch.style.margin = "8px 0";
  tdSwitch.style.width = "fit-content";
}

function hideTdSwitch(tdSwitch) {
  if (tdSwitch) tdSwitch.style.display = "none";
}

function showTdSwitch(tdSwitch) {
  tdSwitch.style.display = "inline-flex";
  styleTdSwitch(tdSwitch);
}

function translateTdSwitch(tdSwitch) {
  if (!tdSwitch) return;
  const incVat = tdSwitch.querySelector('[data-mode="incl"]');
  const exclVat = tdSwitch.querySelector('[data-mode="excl"]');
  if (incVat) incVat.textContent = 'c/ IVA';
  if (exclVat) exclVat.textContent = 's/ IVA';
}

function syncTdSwitch(tdSwitch) {
  if (!tdSwitch) return tdSwitch;

  translateTdSwitch(tdSwitch);

  const isPDP = window.location.pathname.includes("/products/");
  const drawerInner = document.querySelector(".drawer.active .drawer__inner");

  if (isPDP) {
    const priceBlock =
      document.querySelector('[bss-b2b-product-parent-price="true"]') ||
      document
        .querySelector("[bss-b2b-product-price][bss-b2b-product-id]")
        ?.closest(".price");

    if (priceBlock) {
      showTdSwitch(tdSwitch);
      priceBlock.insertAdjacentElement("afterend", tdSwitch);
    }

    return tdSwitch;
  }

  if (!drawerInner) {
    hideTdSwitch(tdSwitch);
    return tdSwitch;
  }

  const target = drawerInner.querySelector(".drawer__heading") || drawerInner;

  showTdSwitch(tdSwitch);
  target.insertAdjacentElement("afterend", tdSwitch);

  return tdSwitch;
}

window.bssB2BHooks.filters["custom:td_switch_position/body"] = function (tdSwitch) {
  return syncTdSwitch(tdSwitch);
};

(function observeDrawerActiveState() {
  function run() {
    syncTdSwitch(document.querySelector(".bss-b2b-td-switch"));
  }

  run();

  const drawer = document.querySelector(".drawer");
  if (!drawer) return;

  new MutationObserver(run).observe(drawer, {
    attributes: true,
    attributeFilter: ["class"],
  });

  document.addEventListener("click", function () {
    setTimeout(run, 300);
  });
})();



